export const ADD_ON_CART_MESSAGES = {
  adjustedTitle: "购物车商品数量有调整",
  adjusted: "商品限购数量有更新，购物车中超出限购的数量已自动调整，请核对后继续下单",
  partiallyAdjusted: "部分商品的超限数量已自动调整，仍有商品调整失败，请核对购物车数量后重试",
  acknowledge: "我知道了",
  loadFailed: "购物车加载失败，请重试",
  updateFailed: "购物车数量调整失败，请重试",
};
